import React, { createContext, useState, useEffect } from "react";
import { API_URL } from "./config";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(API_URL + "validate_session.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include", // Include cookies in the request
                    body: JSON.stringify({ action: "validate_session" }),
                });
                const result = await response.json();
                setIsAuthenticated(result.loggedIn);
            } catch (error) {
                console.error("Error validating session:", error);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;